
import { Table, Stack, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Divider, Grid, Typography, Tooltip, Autocomplete, TextField, InputAdornment, useTheme, Button, Toolbar } from "@mui/material";

import { styled } from '@mui/material/styles';

import { useState, useEffect } from "react";
import Cancel from '@mui/icons-material/CancelOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import PropTypes from 'prop-types';
import Header from "../../../Layout/Header";

import PreviewPurchaseIndentEmail from "./PreviewPurchaseIndentEmail";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';


import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import CallAlertBar from "../../../Layout/Alertbar";

import SaveAltIcon from '@mui/icons-material/SaveAlt';

import useDepartment from "../../../hooks/useDepartment";
import useRequestIndentNumberListByDepartment from "../../../hooks/useRequestIndentNumberByDepartmentID";
import useEmployee from "../../../hooks/useEmployee";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import usePurchaseIndentNumber from "../../../hooks/usePurchaseIndentNumber";
import useLoadPurchaseIndentDetailByRequestIndent from "../../../hooks/useLoadPurchaseIndentDetailByRequestIndent";
import usePurchasedIndentCRUD from "../../../hooks/usePurchasedIndentCRUD";
import PurchaseIndentActionMenu from "./PurchaseIndentSubMenu";
import { tokens } from "../../../theme/theme";
import AddNewVendorEnquiry from "../vendor-enquiry/AddVendorEnquiry";


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}





const AddNewPurchaseIndent = ({ handlecallback, editIssueIndentID: editPurchaseIndentID, selectedMode, idDepartment, idRequestIndent }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // Parent Roll  Alert Values
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const [openPreviewModal, setOpenPreviewModal] = useState(false);

    const callMessage = (serverityval, msg, title) => {
        setParentRollSeverityvalue(serverityval);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(title);
        setParentRollMsgOpen(true);
    };

    const callError = (serverityval, msg, title) => {
        // Update state with error message        
        setParentRollSeverityvalue(serverityval);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(title);
        setParentRollMsgOpen(true);
    };


    // List of Parameter
    const [customerNotes, setCustomerNotes] = useState('');
    const [purchaseDate, setPurchasedDate] = useState(dayjs());
    const [tableRows, setTableRows] = useState([{ id_request_det: 1, material_code: '', material_description: '', quantity_approved: 0, quantity_issued: 0, quantity_balance: 0, quantity_to_issue: 0, delivery_date: '' }]);


    // get party list
    const [selectedButtonName, setSelectedButtonName] = useState('');
    const { department, selectedDepartment, selectedDepartmentID, setSelectedDepartment, setSelectedDepartmentID, loadDepartmentByID } = useDepartment(0);
    const { requestIndentNumberList, selectedRequestIndentNumberList, selectedRequestIndentNumberListID, setSelectedRequestIndentNumberList, setSelectedRequestIndentNumberListID, loadIndentNumbersByDepartmentID } = useRequestIndentNumberListByDepartment(0);
    //const { RequestIndentDetail, loadIssueDetailByRequestIndentID, } = useLoadIssueDetailByRequestNumber();
    const { purchaseIndentNumber, setPurchaseIndentNumber, loadPurchaseIndentNumberByID } = usePurchaseIndentNumber(0);
    const { employee, selectedEmployee, selectedEmployeeID, setSelectedEmployee, setSelectedEmployeeID, loadEmployeeByID, } = useEmployee(editPurchaseIndentID);
    const { processIndent } = usePurchasedIndentCRUD(callMessage);
    const { RequestIndentDetail, loadPurchaseDetailByRequestIndentID, } = useLoadPurchaseIndentDetailByRequestIndent();
    const [allPOData, setAllPOData] = useState({});
    const [disableSave, setDisableSave] = useState(false);
    const [viewAddVendorEnquiryUI, setViewAddVendorEnquiryUI] = useState(false);
    const [viewPurchaseindent, setViewPurchaseindent] = useState(true);
    const [editMode, setEditMode] = useState(false);

    const callback = () => {
        handlecallback();
    }

    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
    ))({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: colors.blueAccent[500],
            color: 'white',
            fontSize: '14px',
            borderRadius: '10px',
            padding: '10px',

        },
        [`& .MuiTooltip-arrow`]: {
            color: colors.blueAccent[500],
        },
    });

    const [isLoadEditPO, setLoadEditPO] = useState(false);


    useEffect(() => {
        if (RequestIndentDetail && RequestIndentDetail?.length > 0) {
            //let valid_data=RequestIndentDetail.map((e)=>e.quantity_to_require>0);
            let valid_data = RequestIndentDetail.filter((e) => e.quantity_to_require > 0);
            setTableRows(valid_data);
            //quantity_to_require
        }

    }, [RequestIndentDetail])

    useEffect(() => {
        if (idRequestIndent !== 0 && idRequestIndent !== undefined)

            loadDepartmentByID(idDepartment);
        //loadPurchaseDetailByRequestIndentID(idRequestIndent, purchaseIndentNumber);
        loadIndentNumbersByDepartmentID(idDepartment, 'purchase indent', idRequestIndent);
        setSelectedRequestIndentNumberListID(idRequestIndent);
        setEditMode(false);
        loadEmployeeByID(idRequestIndent);

        getRequestDetailByRequestID(idRequestIndent);


    }, [idRequestIndent, idDepartment]);

    useEffect(() => {

        if (!isLoadEditPO && editPurchaseIndentID !== 0 && idRequestIndent === undefined) {
            setEditMode(true);
            try {
                const fetchData = async () => {

                    const para = {
                        p_companyid: localStorage.getItem("companyid"),
                        p_plantid: 1,
                        p_id_purchase: editPurchaseIndentID,
                    };

                    const purchaseOrderResponse = await callApi(API_ENDPOINTS.PURCHASED_INDENT_GET_DETAIL_BY_ID, 'POST', { 'Content-Type': 'application/json' }, para);
                    const purchaseOrder = purchaseOrderResponse[0];

                    if (purchaseOrder) {
                        setPurchaseIndentNumber(purchaseOrder.purchase_indent_number);
                        setPurchasedDate(purchaseOrder.purchase_date);

                        await loadEmployeeByID(purchaseOrder.id_requester);
                        await loadDepartmentByID(purchaseOrder.id_department);
                        await loadPurchaseDetailByRequestIndentID(purchaseOrder.id_request, purchaseOrder.purchase_indent_number);
                        await loadIndentNumbersByDepartmentID(purchaseOrder.id_department, 'purchase indent', purchaseOrder.id_request)
                        setAllPOData(purchaseOrder);
                    }
                };

                fetchData();
            } catch (error) {
                callMessage('error', error.message, 'Error');
            }
        }

    }, [isLoadEditPO, editPurchaseIndentID]);



    const getRequestDetailByRequestID = async (id_request) => {
        await loadPurchaseDetailByRequestIndentID(id_request, '');
    }

    const handleQuantityChange = (index, quantity) => {
        setTableRows((prevRows) => {
            return prevRows.map((row, i) => {
                if (i === index) {
                    return row.quantity_balance < quantity
                        ? row  // Return unchanged row if condition is not met
                        : { ...row, quantity_to_issue: quantity }; // Create a new object for state change detection
                }
                return row;
            });
        });
    };



    const handleSaveAndDraft = () => {

        const modifiedRows = tableRows.map(({ material_code, material_description, material_uom, ...rest }) => rest);

        if (!purchaseIndentNumber || purchaseIndentNumber === '') {
            callError('warning', 'Purchase Indent Number is required', 'Validation');
            return;
        }

        if (!selectedDepartmentID || selectedDepartmentID === 0) {
            callError('warning', 'Department is required', 'Validation');
            return;
        }

        if (selectedRequestIndentNumberListID === 0 || selectedRequestIndentNumberListID === undefined) {
            callError('warning', 'Request Indent Number is required', 'Validation');
            return;
        }

        if (!selectedEmployeeID || selectedEmployeeID === 0) {
            callError('warning', 'Requested by is required', 'Validation');
            return;
        }

        if (!purchaseDate || purchaseDate === null) {
            callError('warning', 'Purchase Date is required', 'Validation');
            return;
        }


        if (modifiedRows.length === 0 || modifiedRows[0].id_material === 0) {
            callError('warning', 'At least one item is required in the request indent', 'Validation');
            return;
        }

        if (modifiedRows.some(row => row.quantity_to_require <= 0)) {
            callError('warning', 'Quantity to require must be greater than zero', 'Validation');
            return;
        }

        let mode_id = 0;
        if (editPurchaseIndentID != 0) {
            mode_id = 1;
        }
        let id_request = editPurchaseIndentID !== 0 ? editPurchaseIndentID : 0;

        const requestBody = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_id_purchase: id_request,
            p_id_request: selectedRequestIndentNumberListID,
            p_mode: mode_id,
            p_id_requester: selectedEmployeeID,
            p_id_department: selectedDepartmentID,
            p_purchase_indent_number: purchaseIndentNumber,
            p_purchase_date: dayjs(purchaseDate).format('YYYY-MM-DD hh:mm:ss'),
            p_status: 'Created',
            p_remarks: customerNotes,
            p_purchaseitem_list: modifiedRows,

        }
        processIndent(selectedMode, editPurchaseIndentID, requestBody);

        //disable save button 
        setDisableSave(true);

    };


    const handleDateChange = (index, date) => {
        const newRows = [...tableRows];
        newRows[index].delivery_date = date ? date.format('YYYY-MM-DD') : '';  // Format date correctly
        setTableRows(newRows);
    };

    const handleSendEmail = async (to, cc) => {
        try {
            const response = await callApi(API_ENDPOINTS.SEND_EMAIL, 'POST', { 'Content-Type': 'application/json' }, {
                to,
                cc,
                subject: `Purchase Order ${allPOData.purchaseOrderNumber}`,
                body: JSON.stringify(allPOData) // This could be formatted as HTML for better presentation
            });

            if (response.success) {
                alert('Email sent successfully');
            } else {
                alert('Failed to send email');
            }
        } catch (error) {
            callError('error', error.message, 'Error');
        }
    };

    const handlecallProcess = (buttonName) => {
        if (buttonName === 'Email') {
            setOpenPreviewModal(true);
        }
        else if (buttonName === 'CreateNewEnquiry') {
            setViewAddVendorEnquiryUI(true);
             setViewPurchaseindent(false);
        }


    };

    const handlecallbackFromVendorEnquiry = () => {
        setViewAddVendorEnquiryUI(false);
        setViewPurchaseindent(true);

    }

    return (<>

        {viewPurchaseindent && (
            <Box padding={0}>

                <Header title={editPurchaseIndentID === 0 ? 'New Indent Purchase' : 'Edit Indent Purchase'} subtitle="" callback={callback} />
                <Divider />
                {editPurchaseIndentID > 0 && (
                    <>
                        <PurchaseIndentActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} />
                        <Divider />
                    </>
                )}

                <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                    setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                    setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        px: 1,
                        py: 1
                    }}
                >
                    <Typography variant="h6"  >
                        <span style={{ color: 'red' }}>*</span> Mandatory fields
                    </Typography>
                </Box>
                <Box
                    sx={{
                        padding: "5px",
                        borderRadius: "10px",
                        maxHeight: {
                            xs: '72vh', // Extra small devices (phones)
                            sm: '72vh', // Small devices (tablets)
                            md: '74vh', // Medium devices (small laptops)
                            lg: '74vh', // Large devices (desktops)
                            xl: '82vh', // Extra large devices (large desktops)
                        },
                        overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                        '&::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: colors.primary[400],
                            borderRadius: '10px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: colors.blueAccent[600],
                            borderRadius: '10px',
                            '&:hover': {
                                background: colors.blueAccent[800],
                            },
                        },
                        '&::-webkit-scrollbar-corner': {
                            background: colors.primary[700],
                        }
                    }}>

                    <Grid container  >

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ backgroundColor: colors.primary[400] }}  >
                            <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Purchase Indent # <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                    <TextField value={purchaseIndentNumber} fullWidth size="small" label="" required variant="outlined"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="start">
                                                    <CustomTooltip
                                                        title={
                                                            <span>
                                                                <b>click here to enable or disable auto generation of purchase order number.</b> <br />
                                                            </span>}
                                                    >
                                                        <SettingsIcon style={{ fontSize: "20px" }} />
                                                    </CustomTooltip>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                            </Grid>



                        </Grid>

                        <Grid item xs={12} xl={12} >

                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Department <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={department}
                                        value={selectedDepartment}
                                        disabled={editMode}
                                        onChange={(event, newValue) => {
                                            setSelectedDepartment(newValue);
                                            setSelectedDepartmentID(newValue.id);
                                            loadIndentNumbersByDepartmentID(newValue.id, 'issue indent');
                                        }}
                                        getOptionLabel={(option) => option.description || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Request Indent # <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>

                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={requestIndentNumberList}
                                        value={selectedRequestIndentNumberList}
                                        disabled={editMode}
                                        onChange={(event, newValue) => {
                                            setSelectedRequestIndentNumberList(newValue);
                                            setSelectedRequestIndentNumberListID(newValue.id_request);
                                            getRequestDetailByRequestID(newValue.id_request);
                                        }}
                                        getOptionLabel={(option) => option.request_indent_number || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Requested By <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={employee}
                                        value={selectedEmployee}
                                        onChange={(event, newValue) => {
                                            setSelectedEmployee(newValue);
                                            setSelectedEmployeeID(newValue.id);

                                        }}
                                        getOptionLabel={(option) => option.name || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={11} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Purchase Date <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Stack spacing={2}>
                                            <DatePicker
                                                size="small"
                                                id="Orderdate"
                                                format="DD-MMM-YYYY"
                                                value={dayjs(purchaseDate)}
                                                onChange={(date) => setPurchasedDate(date)}
                                                slotProps={{ textField: { size: 'small' } }}
                                                fullWidth
                                                className="customDatePicker"
                                                renderInput={(props) => (
                                                    <TextField required {...props} />
                                                )}
                                            />
                                        </Stack>
                                    </LocalizationProvider>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid item xs={12} lg={12} xl={10} mt={5} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={11} md={12} lg={12} xl={12} display="flex-start" justifyContent="center" >
                                    <CustomTableContainer colors={colors}>
                                        <TableContainer>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Matrial Code</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center', width: 250 }}>Description</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Requested Qty.</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>UOM</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Available In Store</TableCell>
                                                        {editPurchaseIndentID == 0 ?
                                                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Required</TableCell>
                                                            : <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Current Required</TableCell>}

                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Quantity to be Ordered</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center', width: 200 }}>Delivery Date</TableCell>

                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableRows.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ size: "small", width: "300px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                <TextField
                                                                    fullWidth
                                                                    disabled
                                                                    size="small"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '8px',
                                                                            textAlign: 'center',
                                                                        },
                                                                    }}
                                                                    variant="outlined"
                                                                    type="text"
                                                                    value={`${row.material_code} `}
                                                                />
                                                            </TableCell>
                                                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '8px',
                                                                            textAlign: 'center',
                                                                        },
                                                                    }}
                                                                    value={row.material_description}
                                                                    variant="outlined"
                                                                    disabled
                                                                />
                                                            </TableCell>

                                                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 10, textAlign: 'right' }}>
                                                                <TextField
                                                                    fullWidth
                                                                    disabled
                                                                    size="small"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '8px',
                                                                            textAlign: 'right',
                                                                        },
                                                                    }}
                                                                    variant="outlined"
                                                                    type="number"
                                                                    value={row.quantity_approved}

                                                                />
                                                            </TableCell>
                                                            <TableCell style={{ size: "small", width: "300px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                <TextField
                                                                    fullWidth
                                                                    disabled
                                                                    size="small"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '8px',
                                                                            textAlign: 'center',
                                                                        },
                                                                    }}
                                                                    variant="outlined"
                                                                    type="text"
                                                                    value={`${row.material_uom} `}
                                                                />
                                                            </TableCell>

                                                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                <TextField
                                                                    fullWidth
                                                                    disabled
                                                                    size="small"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '8px',
                                                                            textAlign: 'right',
                                                                        },
                                                                    }}
                                                                    variant="outlined"
                                                                    type="number"
                                                                    value={row.quantity_available}
                                                                />
                                                            </TableCell>
                                                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                <TextField
                                                                    fullWidth
                                                                    disabled
                                                                    size="small"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '8px',
                                                                            textAlign: 'right',
                                                                        },
                                                                    }}
                                                                    variant="outlined"
                                                                    type="number"
                                                                    value={row.quantity_required}
                                                                />
                                                            </TableCell>

                                                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '8px',
                                                                            textAlign: 'right',
                                                                        },
                                                                    }}
                                                                    variant="outlined"
                                                                    type="number"
                                                                    value={row.quantity_to_require}
                                                                    onChange={(e) => handleQuantityChange(index, e.target.value)}
                                                                />
                                                            </TableCell>

                                                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 10, textAlign: 'right' }}>
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <Stack spacing={2}>
                                                                        <DatePicker
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiSelect-select': {
                                                                                    padding: '0px',
                                                                                },
                                                                            }}
                                                                            size="small"
                                                                            format="DD-MMM-YYYY"
                                                                            id="Orderdate"
                                                                            value={row.delivery_date ? dayjs(row.delivery_date) : null} // Convert to dayjs
                                                                            onChange={(date) => handleDateChange(index, date)} // Pass correct parameters
                                                                            slotProps={{ textField: { size: 'small' } }}
                                                                            fullWidth
                                                                            className="customDatePicker"
                                                                            renderInput={(props) => (
                                                                                <TextField required {...props} />
                                                                            )}
                                                                        />
                                                                    </Stack>
                                                                </LocalizationProvider>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </CustomTableContainer>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} lg={12} xl={12} mt={1} padding={2} >
                            <Box padding={1} sx={{
                                display: 'flex',
                                alignItems: 'center',
                                borderColor: 'divider',
                                borderRadius: 2,
                                color: 'text.secondary', '& svg': { m: 1, },
                            }} >
                                <Grid container spacing={0}>
                                    <Grid item xs={6} lg={6.4} xl={6} marginRight={1}>
                                        <Typography variant="h5" fontWeight="bold">Notes (For Internal Use) </Typography>
                                        <Grid item xs={12} lg={12} xl={10}>
                                            <TextField
                                                id="outlined-multiline-static"
                                                value={customerNotes}
                                                onChange={(e) => setCustomerNotes(e.target.value)}
                                                placeholder="Enter the issuer notes , will appear the issue indent."
                                                multiline
                                                rows={4}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>

                    </Grid>
                </Box>

                <Grid container>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <Box position="fixed" sx={{ top: 'auto', bottom: 0 }}>
                            <Toolbar>
                                <Button size="small" variant="contained" disabled={disableSave} color="secondary" onClick={handleSaveAndDraft} startIcon={<SaveAltIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save Required</Button>
                                <Button size="small" variant="contained" style={{ backgroundColor: "maroon" }} startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button>
                            </Toolbar>
                        </Box>
                    </Grid>
                </Grid>

            </Box>
        )}

        <PreviewPurchaseIndentEmail
            open={openPreviewModal}
            onClose={() => setOpenPreviewModal(false)}
            onSend={handleSendEmail}
            poData={allPOData}
        />

        {viewAddVendorEnquiryUI && (
   
              <AddNewVendorEnquiry 
              handlecallback={handlecallbackFromVendorEnquiry} 
              editIssueIndentID={0} 
              selectedMode={0}
                callfromPurchaseIndent={true} 

                idDepartment={selectedDepartmentID}
idRequestIndent={editPurchaseIndentID}

                />
            
        )}

    </>)
}
export default AddNewPurchaseIndent;